import { render, staticRenderFns } from "./classDetail2.vue?vue&type=template&id=05d3aad8&scoped=true"
import script from "./classDetail2.vue?vue&type=script&lang=js"
export * from "./classDetail2.vue?vue&type=script&lang=js"
import style0 from "./classDetail2.vue?vue&type=style&index=0&id=05d3aad8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d3aad8",
  null
  
)

export default component.exports